export const timezoneMap = {
  // Asia
  "Asia/Karachi": "Asia/Karachi", // Pakistan
  "Asia/Kolkata": "Asia/Kolkata", // India
  "Asia/Dubai": "Asia/Dubai", // UAE
  "Asia/Riyadh": "Asia/Riyadh", // Saudi Arabia
  "Asia/Baghdad": "Asia/Baghdad", // Iraq
  "Asia/Tehran": "Asia/Tehran", // Iran
  "Asia/Kabul": "Asia/Kabul", // Afghanistan
  "Asia/Tashkent": "Asia/Tashkent", // Uzbekistan
  "Asia/Yekaterinburg": "Asia/Yekaterinburg", // Russia
  "Asia/Dhaka": "Asia/Dhaka", // Bangladesh
  "Asia/Yangon": "Asia/Yangon", // Myanmar
  "Asia/Bangkok": "Asia/Bangkok", // Thailand
  "Asia/Jakarta": "Asia/Jakarta", // Indonesia
  "Asia/Singapore": "Asia/Singapore", // Singapore
  "Asia/Kuala_Lumpur": "Asia/Kuala_Lumpur", // Malaysia
  "Asia/Shanghai": "Asia/Shanghai", // China
  "Asia/Hong_Kong": "Asia/Hong_Kong", // Hong Kong
  "Asia/Taipei": "Asia/Taipei", // Taiwan
  "Asia/Tokyo": "Asia/Tokyo", // Japan
  "Asia/Seoul": "Asia/Seoul", // South Korea
  "Asia/Pyongyang": "Asia/Pyongyang", // North Korea

  // Australia and Pacific
  "Australia/Perth": "Australia/Perth", // Western Australia
  "Australia/Darwin": "Australia/Darwin", // Northern Territory
  "Australia/Adelaide": "Australia/Adelaide", // South Australia
  "Australia/Brisbane": "Australia/Brisbane", // Queensland
  "Australia/Sydney": "Australia/Sydney", // New South Wales
  "Australia/Melbourne": "Australia/Melbourne", // Victoria
  "Australia/Hobart": "Australia/Hobart", // Tasmania
  "Pacific/Auckland": "Pacific/Auckland", // New Zealand
  "Pacific/Fiji": "Pacific/Fiji", // Fiji
  "Pacific/Honolulu": "Pacific/Honolulu", // Hawaii

  // Americas
  "America/New_York": "America/New_York", // Eastern Time
  "America/Chicago": "America/Chicago", // Central Time
  "America/Denver": "America/Denver", // Mountain Time
  "America/Los_Angeles": "America/Los_Angeles", // Pacific Time
  "America/Anchorage": "America/Anchorage", // Alaska
  "America/Halifax": "America/Halifax", // Atlantic Time (Canada)
  "America/St_Johns": "America/St_Johns", // Newfoundland
  "America/Toronto": "America/Toronto", // Eastern Time (Canada)
  "America/Winnipeg": "America/Winnipeg", // Central Time (Canada)
  "America/Edmonton": "America/Edmonton", // Mountain Time (Canada)
  "America/Vancouver": "America/Vancouver", // Pacific Time (Canada)
  "America/Mexico_City": "America/Mexico_City", // Mexico
  "America/Bogota": "America/Bogota", // Colombia
  "America/Lima": "America/Lima", // Peru
  "America/Caracas": "America/Caracas", // Venezuela
  "America/Santiago": "America/Santiago", // Chile
  "America/Buenos_Aires": "America/Buenos_Aires", // Argentina
  "America/Sao_Paulo": "America/Sao_Paulo", // Brazil

  // Europe
  "Europe/London": "Europe/London", // UK
  "Europe/Dublin": "Europe/Dublin", // Ireland
  "Europe/Lisbon": "Europe/Lisbon", // Portugal
  "Europe/Madrid": "Europe/Madrid", // Spain
  "Europe/Paris": "Europe/Paris", // France
  "Europe/Brussels": "Europe/Brussels", // Belgium
  "Europe/Amsterdam": "Europe/Amsterdam", // Netherlands
  "Europe/Berlin": "Europe/Berlin", // Germany
  "Europe/Rome": "Europe/Rome", // Italy
  "Europe/Zurich": "Europe/Zurich", // Switzerland
  "Europe/Vienna": "Europe/Vienna", // Austria
  "Europe/Prague": "Europe/Prague", // Czech Republic
  "Europe/Warsaw": "Europe/Warsaw", // Poland
  "Europe/Budapest": "Europe/Budapest", // Hungary
  "Europe/Stockholm": "Europe/Stockholm", // Sweden
  "Europe/Copenhagen": "Europe/Copenhagen", // Denmark
  "Europe/Oslo": "Europe/Oslo", // Norway
  "Europe/Helsinki": "Europe/Helsinki", // Finland
  "Europe/Athens": "Europe/Athens", // Greece
  "Europe/Bucharest": "Europe/Bucharest", // Romania
  "Europe/Kiev": "Europe/Kiev", // Ukraine
  "Europe/Moscow": "Europe/Moscow", // Russia
  "Europe/Istanbul": "Europe/Istanbul", // Turkey

  // Africa
  "Africa/Cairo": "Africa/Cairo", // Egypt
  "Africa/Johannesburg": "Africa/Johannesburg", // South Africa
  "Africa/Nairobi": "Africa/Nairobi", // Kenya
  "Africa/Lagos": "Africa/Lagos", // Nigeria
  "Africa/Casablanca": "Africa/Casablanca", // Morocco
  "Africa/Tunis": "Africa/Tunis", // Tunisia
  "Africa/Algiers": "Africa/Algiers", // Algeria
  "Africa/Accra": "Africa/Accra", // Ghana
  "Africa/Dakar": "Africa/Dakar", // Senegal

  // Middle East
  "Asia/Jerusalem": "Asia/Jerusalem", // Israel
  "Asia/Beirut": "Asia/Beirut", // Lebanon
  "Asia/Damascus": "Asia/Damascus", // Syria
  "Asia/Amman": "Asia/Amman", // Jordan
  "Asia/Qatar": "Asia/Qatar", // Qatar
};
